/**
 * Header search drawer (snippets/predictive-search.liquid).
 *
 * The drawer itself is the theme <predictive-search-drawer> element (theme.js). This mirrors its
 * open state on <html> ("search-drawer-open") so the page is pushed aside like with the mini cart
 * (custom.css), and closes the mini cart when the search opens: both panels share the right edge.
 */
(() => {
  const OPEN_CLASS = 'search-drawer-open';

  document.addEventListener('openable-element:open', (event) => {
    if (!event.target || event.target.id !== 'search-drawer') {
      return;
    }

    document.documentElement.classList.add(OPEN_CLASS);

    const miniCart = document.getElementById('mini-cart');

    if (miniCart && miniCart.hasAttribute('open')) {
      miniCart.open = false;
    }
  });

  document.addEventListener('openable-element:close', (event) => {
    if (event.target && event.target.id === 'search-drawer') {
      document.documentElement.classList.remove(OPEN_CLASS);
    }
  });
})();
